"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var sampleAppController_1 = require("./../../../facetec/src/sampleAppController");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var update_basket_1 = require("../../api/calls/basket/update_basket");
var all_branches_1 = require("../../api/calls/client/all_branches");
var nearest_branches_1 = require("../../api/calls/client/nearest_branches");
var address_list_1 = require("../../api/calls/user/address_list");
var add_user_address_1 = require("../../api/calls/user/add_user_address");
var basket_1 = require("../../reducers/slices/basket/basket");
var main_1 = require("../../reducers/slices/main");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var get_basket_thunk_1 = require("../../reducers/slices/basket/thunks/get_basket_thunk");
var set_checkout_local_storage_thunk_1 = require("../../reducers/slices/basket/thunks/set_checkout_local_storage_thunk");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var constants_1 = require("./constants");
var symbols_1 = require("../../constants/symbols");
var functions_1 = require("../../constants/functions");
var steps_1 = require("./lay_buys/steps/constants/steps");
var route_names_1 = require("../../constants/route_names");
var control_colors_1 = require("../../constants/control_colors");
var pep_pip_verification_1 = require("./pep_pip_verification");
var application_1 = require("../../api/calls/loan/application");
var create_order_1 = require("../../api/calls/payment-engine/ngenius/create_order");
var device_sale_agreement_1 = require("../../api/calls/sale_agreement/device_sale_agreement");
var airtime_purchases_1 = require("../../api/calls/airtime_purchases/airtime_purchases");
var clear_action_auth_1 = require("../../api/calls/user/authentication/clear_action_auth");
var application_2 = require("../../api/calls/lay-buy/application");
var get_laybuy_1 = require("../../api/calls/lay-buy/get_laybuy");
var getDefaultLaybuyReferences_1 = require("../../helpers/getDefaultLaybuyReferences");
var isIosProduct_1 = require("../../helpers/isIosProduct");
var get_loan_1 = require("../../api/calls/loan/get_loan");
var get_airtime_record_1 = require("../../api/calls/airtime_purchases/get_airtime_record");
var airtimeProductHelper_1 = require("../../helpers/airtimeProductHelper");
// Constants for Sky Virtual Store filtering
var SKY_VIRTUAL_STORE_BRANCH_NUMBER = "skyvirst";
var SKY_VIRTUAL_STORE_DISPLAY_NAME = "sky virtual store";
// Step labels for the checkout stepper. Referenced both by the customSteps
// array (display) and by the geolocation effect's gate (`findIndex`) — kept
// here so the two stay in sync and a future label rename (translation, rebrand)
// can't silently break the gate.
var CHECKOUT_STEP_LABEL_CHOOSE_BRANCH = "Choose Branch";
// StepperControl hides steps before it compares the active step number.
// This helper mirrors that behavior so any code that gates side effects by
// `currentStep` uses the same visible-step numbering the customer sees.
var getVisibleStepIndexByLabel = function (steps, label) {
    var visibleSteps = steps.filter(function (step) { return !step.hidden; });
    return visibleSteps.findIndex(function (step) { return step.label === label; });
};
// Helper function to filter out Sky Virtual Store for lay-buy payments
var filterBranchesForLaybuy = function (branches, paymentMethod) {
    if (paymentMethod !== constants_1.LAYBUY)
        return branches;
    return branches.filter(function (branch) {
        var _a, _b, _c, _d;
        var branchNumber = (_b = (_a = branch.branch) === null || _a === void 0 ? void 0 : _a.branch_number) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        var displayName = (_d = (_c = branch.branch) === null || _c === void 0 ? void 0 : _c.display_name) === null || _d === void 0 ? void 0 : _d.toLowerCase();
        return branchNumber !== SKY_VIRTUAL_STORE_BRANCH_NUMBER && displayName !== SKY_VIRTUAL_STORE_DISPLAY_NAME;
    });
};
// Helper function to filter direct branch objects (for all_branches response)
var filterDirectBranchesForLaybuy = function (branches, paymentMethod) {
    if (paymentMethod !== constants_1.LAYBUY)
        return branches;
    return branches.filter(function (branch) {
        var _a, _b;
        var branchNumber = (_a = branch.branch_number) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        var displayName = (_b = branch.display_name) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        return branchNumber !== SKY_VIRTUAL_STORE_BRANCH_NUMBER && displayName !== SKY_VIRTUAL_STORE_DISPLAY_NAME;
    });
};
var CheckoutPage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var params = (0, react_router_dom_1.useParams)();
    var cookie = new universal_cookie_1.default();
    var payment = params.payment;
    // const ngeniuRedirectURL = process.env.NGENIUS_REDIRECT_URL;
    var ngeniuRedirectURL = window.location.origin;
    var basket = (0, react_redux_1.useSelector)(function (state) { return state.basketState; }).basket;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _v = (0, react_1.useState)(null), selectedBranch = _v[0], setSelectedBranch = _v[1];
    var _w = (0, react_1.useState)(false), saveAddress = _w[0], setSaveAddress = _w[1];
    var _x = (0, react_1.useState)(null), selectedAddress = _x[0], setSelectedAddress = _x[1];
    var _y = (0, react_1.useState)(""), newAddressLabel = _y[0], setNewAddressLabel = _y[1];
    var _z = (0, react_1.useState)(""), newAddressErrorText = _z[0], setNewAddressErrorText = _z[1];
    var _0 = (0, react_1.useState)(0), currentStep = _0[0], setCurrentStep = _0[1];
    var _1 = (0, react_1.useState)(constants_1.COLLECTION), deliveryOrCollection = _1[0], setDeliveryOrCollection = _1[1];
    var _2 = (0, react_1.useState)([]), addressList = _2[0], setAddressList = _2[1];
    var _3 = (0, react_1.useState)(false), isAddingAddress = _3[0], setIsAddingAddress = _3[1];
    var _4 = (0, react_1.useState)([]), plotData = _4[0], setPlotData = _4[1];
    var _5 = (0, react_1.useState)(null), searchAddress = _5[0], setSearchAddress = _5[1];
    var _6 = (0, react_1.useState)(""), specialInstructions = _6[0], setSpecialInstructions = _6[1];
    var _7 = (0, react_1.useState)(false), isGettingBranches = _7[0], setIsGettingBranches = _7[1];
    // Generation counter for the collection-step geolocation effect. Every time
    // the effect re-runs (e.g. user searches an address, switches to delivery,
    // navigates between steps), we increment this. In-flight `getCurrentPosition`
    // callbacks from older runs check their captured generation before applying
    // results — a stale callback can no longer overwrite the store list after
    // the user has manually searched or changed mode.
    var geolocationGenRef = (0, react_1.useRef)(0);
    // Loading ownership for nearest-branch lookups. Multiple async actions can
    // overlap here (GPS prompt, default branch lookup, manual address search), so
    // only the newest lookup is allowed to turn the shared loader off.
    var nearestBranchesLoadingGenRef = (0, react_1.useRef)(0);
    var _8 = (0, react_1.useState)(false), airtimeOnly = _8[0], setAirtimeOnly = _8[1];
    var _9 = (0, react_1.useState)(""), branchSearchText = _9[0], setBranchSearchText = _9[1];
    var _10 = (0, react_1.useState)(false), isLoading = _10[0], setIsLoading = _10[1];
    var _11 = (0, react_1.useState)(false), rechargingAnotherParty = _11[0], setRechargingAnotherParty = _11[1];
    var _12 = (0, react_1.useState)(constants_1.CARD), paymentMethod = _12[0], setPaymentMethod = _12[1];
    var _13 = (0, react_1.useState)(null), nearestBranches = _13[0], setNearestBranches = _13[1];
    var _14 = (0, react_1.useState)(null), allBranches = _14[0], setAllBranches = _14[1];
    var _15 = (0, react_1.useState)(""), term = _15[0], setTerm = _15[1];
    var _16 = (0, react_1.useState)({
        phone_number: "081",
        country_code: "+264",
        country_abbreviation: "NA",
    }), rechargePhoneNumber = _16[0], setRechargePhoneNumber = _16[1];
    var _17 = (0, react_1.useState)(null), formData = _17[0], setFormData = _17[1];
    var _18 = (0, react_1.useState)(false), ngeniusLoading = _18[0], setNgeniusLoading = _18[1];
    var intervalId;
    (0, react_1.useEffect)(function () {
        var _a;
        if (!basket) {
            navigate("/shop");
        }
        else {
            dispatch((0, basket_1.setDeliveryMethod)(null));
            setPaymentMethod(payment && payment === "lay-buy" ? constants_1.LAYBUY : constants_1.CARD);
            (0, address_list_1.address_list)({
                user_id: (_a = user === null || user === void 0 ? void 0 : user.integration_id) !== null && _a !== void 0 ? _a : "",
            }).then(function (response) {
                if (response.success) {
                    setAddressList(response.content.addresses);
                }
                else {
                    dispatch((0, main_1.setMessageModal)({
                        title: "Something went wrong!",
                        messages: [response.message],
                    }));
                }
            });
            // pay_with_payfast({
            //   integration_id: user?.uid ?? "",
            //   return_url: "https://ackermans-pharmacy-web-dev-pdstjj77fq-ew.a.run.app/#/return_url",
            //   cancel_url: "https://ackermans-pharmacy-web-dev-pdstjj77fq-ew.a.run.app/#/cancel_url",
            //   name_first: user.name,
            //   name_last: user.surname,
            //   phone_number: user.cell_number,
            //   amount: "13.00",
            //   item_name: "Test Product",
            // }).then((response: any) => {
            //   if (response.success) {
            //     setFormData(response.content);
            //   } else {
            //     dispatch(setMessageModal({ title: "Could not generate PayFast form!", messages: [response.message] }));
            //   }
            // });
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (basket) {
            checkAirtime();
        }
    }, [basket]);
    var checkAirtime = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, functions_1.isAirtimeOnly)(basket === null || basket === void 0 ? void 0 : basket.product_list)];
                case 1:
                    _res = _a.sent();
                    setAirtimeOnly(_res);
                    return [2 /*return*/];
            }
        });
    }); };
    var startNearestBranchesLoading = function () {
        var loadingGen = ++nearestBranchesLoadingGenRef.current;
        setIsGettingBranches(true);
        return loadingGen;
    };
    var stopNearestBranchesLoading = function (loadingGen) {
        if (nearestBranchesLoadingGenRef.current === loadingGen) {
            setIsGettingBranches(false);
        }
    };
    var getUserLocation = function () {
        // Shares the geolocation generation counter with the collection-step effect.
        // If the user clicks "Find a store near me" and then types a different
        // address (or switches mode) before the GPS prompt resolves, the in-flight
        // callback below will see a mismatched generation and bail without
        // clobbering the manual selection.
        var myGen = ++geolocationGenRef.current;
        var loadingGen = startNearestBranchesLoading();
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                if (geolocationGenRef.current !== myGen) {
                    stopNearestBranchesLoading(loadingGen);
                    return;
                }
                setSearchAddress({
                    fullAddress: "User Location",
                    coordinates: {
                        lng: position.coords.longitude,
                        lat: position.coords.latitude,
                    },
                });
                stopNearestBranchesLoading(loadingGen);
            }, function (error) {
                if (geolocationGenRef.current !== myGen) {
                    stopNearestBranchesLoading(loadingGen);
                    return;
                }
                console.error(error);
                stopNearestBranchesLoading(loadingGen);
            }, { timeout: 10000, maximumAge: 60000 });
        }
        else {
            stopNearestBranchesLoading(loadingGen);
        }
    };
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (selectedBranch) {
            (0, update_basket_1.update_basket)({
                _id: (_a = basket === null || basket === void 0 ? void 0 : basket._id) !== null && _a !== void 0 ? _a : "",
                basket: {
                    branch_id: (_b = selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.branch) === null || _b === void 0 ? void 0 : _b._id,
                },
            }).then(function (response) {
                if (response.success) {
                    dispatch((0, get_basket_thunk_1.get_basket_thunk)({ basket_id: basket === null || basket === void 0 ? void 0 : basket._id }));
                }
            });
        }
    }, [selectedBranch]);
    (0, react_1.useEffect)(function () {
        if (selectedAddress && deliveryOrCollection === constants_1.DELIVERY) {
            var isActive_1 = true;
            var loadingGen_1 = startNearestBranchesLoading();
            (0, nearest_branches_1.nearest_branches)({
                order_type: deliveryOrCollection,
                size: "10",
                center_coordinates: {
                    longitude: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.longitude,
                    latitude: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.latitude,
                },
            }).then(function (response) {
                var _a;
                if (!isActive_1 || nearestBranchesLoadingGenRef.current !== loadingGen_1) {
                    return;
                }
                stopNearestBranchesLoading(loadingGen_1);
                if (response.success) {
                    var filteredBranches = ((_a = response.content) !== null && _a !== void 0 ? _a : []).filter(function (x) { return !x.branch.offline; });
                    filteredBranches = filterBranchesForLaybuy(filteredBranches, paymentMethod);
                    setNearestBranches(filteredBranches);
                }
                else {
                    dispatch((0, main_1.setMessageModal)({
                        title: "Could not get nearest branches!",
                        messages: [response.message],
                    }));
                }
            });
            return function () {
                isActive_1 = false;
                stopNearestBranchesLoading(loadingGen_1);
            };
        }
    }, [selectedAddress, deliveryOrCollection]);
    (0, react_1.useEffect)(function () {
        // For collection, show 6 nearest stores by default.
        // Order of preference: upstream user.location → live geolocation → Windhoek centre.
        //
        // Bump the generation counter on EVERY run, before the gate check. Any
        // callbacks still in-flight from a previous run will see a mismatched
        // generation and bail. This is what protects against the search-while-GPS-
        // pending race (user types a city, GPS resolves seconds later, callback
        // would otherwise overwrite the search results).
        var myGen = ++geolocationGenRef.current;
        var isActive = true;
        var loadingGen = null;
        var stopActiveNearestBranchesLoading = function () {
            if (loadingGen !== null) {
                stopNearestBranchesLoading(loadingGen);
            }
        };
        // Gate: only fire while the user is on the visible Choose Branch step.
        // Firing earlier would (a) prompt the user for location before there's any
        // contextual reason to, and (b) leave `isGettingBranches=true` while the
        // browser prompt is unanswered, which disables the Next button on the
        // payment step and can strand users who ignore the prompt.
        var branchStepIdx = getVisibleStepIndexByLabel(customSteps, CHECKOUT_STEP_LABEL_CHOOSE_BRANCH);
        var onBranchStep = branchStepIdx >= 0 && currentStep === branchStepIdx;
        if (deliveryOrCollection === constants_1.COLLECTION && !searchAddress && onBranchStep) {
            loadingGen = startNearestBranchesLoading();
            var WINDHOEK_DEFAULT_1 = { longitude: "16.9798253", latitude: "-22.5635767" };
            var fetchNearestBranches_1 = function (coordinates) {
                (0, nearest_branches_1.nearest_branches)({
                    size: "6",
                    center_coordinates: coordinates,
                }).then(function (response) {
                    var _a;
                    // If a newer run has started (user searched, switched mode, or navigated),
                    // drop this stale result so it doesn't overwrite the now-current store list.
                    // Only the active lookup can clear the loader, so an old GPS/API callback
                    // cannot hide the loader for a newer manual search.
                    if (!isActive || geolocationGenRef.current !== myGen) {
                        stopActiveNearestBranchesLoading();
                        return;
                    }
                    if (response.success) {
                        var filteredBranches = ((_a = response.content) !== null && _a !== void 0 ? _a : []).filter(function (x) { return !x.branch.offline; });
                        filteredBranches = filterBranchesForLaybuy(filteredBranches, paymentMethod);
                        setNearestBranches(filteredBranches);
                    }
                    stopActiveNearestBranchesLoading();
                });
            };
            var userLocation = user === null || user === void 0 ? void 0 : user.location;
            if ((userLocation === null || userLocation === void 0 ? void 0 : userLocation.lat) && (userLocation === null || userLocation === void 0 ? void 0 : userLocation.lon)) {
                fetchNearestBranches_1({
                    longitude: userLocation.lon.toString(),
                    latitude: userLocation.lat.toString(),
                });
            }
            else if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    // Stale callback (user searched / switched mode while GPS was pending). Bail.
                    if (!isActive || geolocationGenRef.current !== myGen) {
                        stopActiveNearestBranchesLoading();
                        return;
                    }
                    fetchNearestBranches_1({
                        longitude: position.coords.longitude.toString(),
                        latitude: position.coords.latitude.toString(),
                    });
                }, function (error) {
                    // Stale callback — see note in the success handler above.
                    if (!isActive || geolocationGenRef.current !== myGen) {
                        stopActiveNearestBranchesLoading();
                        return;
                    }
                    console.warn("Geolocation unavailable, defaulting to Windhoek centre:", error);
                    fetchNearestBranches_1(WINDHOEK_DEFAULT_1);
                }, { timeout: 10000, maximumAge: 60000 });
            }
            else {
                fetchNearestBranches_1(WINDHOEK_DEFAULT_1);
            }
        }
        return function () {
            isActive = false;
            stopActiveNearestBranchesLoading();
        };
    }, [deliveryOrCollection, searchAddress, user === null || user === void 0 ? void 0 : user.location, paymentMethod, currentStep]);
    (0, react_1.useEffect)(function () {
        if (searchAddress && searchAddress.fullAddress) {
            var isActive_2 = true;
            var loadingGen_2 = startNearestBranchesLoading();
            (0, nearest_branches_1.nearest_branches)({
                size: "6",
                center_coordinates: {
                    longitude: "".concat(searchAddress.coordinates.lng),
                    latitude: "".concat(searchAddress.coordinates.lat),
                },
            }).then(function (response) {
                var _a;
                if (!isActive_2 || nearestBranchesLoadingGenRef.current !== loadingGen_2) {
                    return;
                }
                if (response.success) {
                    var filteredBranches = ((_a = response.content) !== null && _a !== void 0 ? _a : []).filter(function (x) { return !x.branch.offline; });
                    filteredBranches = filterBranchesForLaybuy(filteredBranches, paymentMethod);
                    setNearestBranches(filteredBranches);
                    stopNearestBranchesLoading(loadingGen_2);
                }
                else {
                    dispatch((0, main_1.setMessageModal)({
                        title: "Could not get nearest branches!",
                        messages: [response.message],
                    }));
                    stopNearestBranchesLoading(loadingGen_2);
                }
            });
            return function () {
                isActive_2 = false;
                stopNearestBranchesLoading(loadingGen_2);
            };
        }
    }, [searchAddress, paymentMethod]);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        if (nearestBranches && nearestBranches.length > 0) {
            var mapPoints = [];
            for (var _i = 0, _e = nearestBranches !== null && nearestBranches !== void 0 ? nearestBranches : []; _i < _e.length; _i++) {
                var branch = _e[_i];
                mapPoints.push({
                    position: {
                        lat: Number((_b = (_a = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.latitude),
                        lng: Number((_d = (_c = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.longitude),
                    },
                    info: branch === null || branch === void 0 ? void 0 : branch.branch.display_name,
                });
            }
            setPlotData(mapPoints);
        }
    }, [nearestBranches]);
    (0, react_1.useEffect)(function () {
        setIsGettingBranches(true);
        (0, all_branches_1.all_branches)().then(function (response) {
            var _a;
            setIsGettingBranches(false);
            if (response.success) {
                var branchList = (_a = response.content) === null || _a === void 0 ? void 0 : _a.branch_list;
                branchList = filterDirectBranchesForLaybuy(branchList, paymentMethod);
                setAllBranches(branchList);
            }
            else {
                dispatch((0, main_1.setMessageModal)({
                    title: "Could not get all branches!",
                    messages: [response.message],
                }));
            }
        });
    }, [paymentMethod]);
    (0, react_1.useEffect)(function () {
        //Check Delivery Method
        if (deliveryOrCollection && paymentMethod == constants_1.CARD) {
            if (deliveryOrCollection == constants_1.DELIVERY) {
                setDefaultBranch();
            }
            else {
                //Force user to select branch
                setSelectedBranch(null);
            }
        }
    }, [deliveryOrCollection]);
    (0, react_1.useEffect)(function () {
        //Check Payment Method
        if (paymentMethod == constants_1.LOAN) {
            setDeliveryOrCollection(constants_1.COLLECTION);
            if (airtimeOnly) {
                setDefaultBranch();
            }
        }
        if (paymentMethod == constants_1.LAYBUY) {
            // For lay-buy, let user choose delivery or collection
            setDeliveryOrCollection(constants_1.COLLECTION); // Default to collection
        }
        if (paymentMethod == constants_1.CARD) {
            if (airtimeOnly) {
                setDefaultBranch();
            }
        }
    }, [paymentMethod]);
    var setDefaultBranch = function () {
        // Guard: Ensure branches are loaded before iterating
        if (!allBranches || !Array.isArray(allBranches)) {
            return;
        }
        allBranches.forEach(function (branch) {
            // For lay-buy, exclude Sky Virtual Store
            if (paymentMethod === constants_1.LAYBUY) {
                if ((branch === null || branch === void 0 ? void 0 : branch.branch_number.toLowerCase()) !== SKY_VIRTUAL_STORE_BRANCH_NUMBER && (branch === null || branch === void 0 ? void 0 : branch.display_name.toLowerCase()) !== SKY_VIRTUAL_STORE_DISPLAY_NAME) {
                    setSelectedBranch({ branch: branch });
                    return;
                }
            }
            else {
                // For other payment methods, allow Sky Virtual Store
                if ((branch === null || branch === void 0 ? void 0 : branch.branch_number.toLowerCase()) === SKY_VIRTUAL_STORE_BRANCH_NUMBER || (branch === null || branch === void 0 ? void 0 : branch.display_name.toLowerCase()) === SKY_VIRTUAL_STORE_DISPLAY_NAME) {
                    setSelectedBranch({ branch: branch });
                    return;
                }
            }
        });
    };
    var onNext = function () {
        var nextStep = currentStep + 1;
        if (nextStep < customSteps.length) {
            setCurrentStep(nextStep);
        }
    };
    var onPrevious = function () {
        var nextStep = currentStep - 1;
        if (currentStep > 0) {
            setCurrentStep(nextStep);
        }
    };
    var validatePaymentMethod = function () {
        var messages = [];
        if (!paymentMethod) {
            messages.push("Please select a payment method.");
        }
        if (messages.length > 0) {
            dispatch((0, main_1.setMessageModal)({ title: "Payment method needed", messages: messages }));
            return false;
        }
        else {
            return true;
        }
    };
    var validateDeliveryMethod = function () {
        var messages = [];
        if (!deliveryOrCollection) {
            messages.push("Please select a delivery method.");
        }
        // else {
        //   if (deliveryOrCollection == COLLECTION) {
        //     if (!selectedBranch || !selectedBranch.branch) {
        //       messages.push("Unfortunately, we were unable to retrieve branches, please contact support.");
        //     }
        //   }
        // }
        if (messages.length > 0) {
            dispatch((0, main_1.setMessageModal)({ title: "Delivery method needed", messages: messages }));
            return false;
        }
        else {
            return true;
        }
    };
    var validateRechargePhoneNumber = function () {
        var messages = [];
        if (rechargingAnotherParty) {
            if (!(rechargePhoneNumber === null || rechargePhoneNumber === void 0 ? void 0 : rechargePhoneNumber.phone_number)) {
                messages.push("Please enter phone number.");
            }
            else {
                if (!doshx_controls_web_1.Utilities.isValidPhoneNumber(rechargePhoneNumber.phone_number, rechargePhoneNumber === null || rechargePhoneNumber === void 0 ? void 0 : rechargePhoneNumber.country_abbreviation)) {
                    messages.push("Invalid number entered.");
                }
                //validate the number here
                var number = rechargePhoneNumber === null || rechargePhoneNumber === void 0 ? void 0 : rechargePhoneNumber.phone_number.replace(/\D/g, "");
                var correcNumberLocation = number.substring(0, 3) === "081";
                // Check if the resulting string has exactly 10 characters and if starts with 081
                if (number.length !== 10 && !correcNumberLocation) {
                    messages.push("The number must be 10 digits long, and should start with 081.");
                }
            }
        }
        if (messages.length > 0) {
            dispatch((0, main_1.setMessageModal)({ title: "Invalid Number Entered.", messages: messages }));
            return false;
        }
        else {
            return true;
        }
    };
    var validateAddress = function () {
        var messages = [];
        var errorCount = 0;
        if (!selectedAddress) {
            messages.push("Please select an address, or add a new address in order to continue.");
        }
        // if (!selectedBranch) {
        //   messages.push("Unfortunately, we do not deliver to this address. Please select a different address, or choose to collect.");
        // }
        if (saveAddress && !newAddressLabel) {
            errorCount++;
            setNewAddressErrorText("Please enter a label for your new address.");
        }
        if (messages.length > 0 || errorCount > 0) {
            if (messages.length > 0) {
                dispatch((0, main_1.setMessageModal)({ title: "Address selection needed!", messages: messages }));
            }
            return false;
        }
        else {
            return true;
        }
    };
    // create a function with an object as a promise return type
    var generateStoreListing = function (nearestBranches) {
        return new Promise(function (resolve, reject) {
            // create a promise
            var storeListing = nearestBranches.map(function (branch, index) {
                // create a store listing
                return { label: branch.branch.display_name, value: branch.branch.display_name }; // return the store listing
            });
            resolve(storeListing); // resolve the promise
        });
    };
    var saveLoanDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var loanProducts, _i, _a, product, activeLoan, loanResponse, loanAirtimeProducts_1, activeAirtimePurchase, devicesAmount, hasDevices, orderProducts, saleAgreement;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    setIsLoading(true);
                    loanProducts = [];
                    for (_i = 0, _a = basket.product_list; _i < _a.length; _i++) {
                        product = _a[_i];
                        loanProducts.push({
                            name: product === null || product === void 0 ? void 0 : product.title,
                            price: product === null || product === void 0 ? void 0 : product.price,
                            quantity: product === null || product === void 0 ? void 0 : product.quantity,
                            category_id: (_b = product === null || product === void 0 ? void 0 : product.category) === null || _b === void 0 ? void 0 : _b._id,
                            id: product === null || product === void 0 ? void 0 : product._id,
                            sku: product === null || product === void 0 ? void 0 : product.sku,
                        });
                    }
                    return [4 /*yield*/, (0, get_loan_1.getActiveLoan)({ basket_id: basket === null || basket === void 0 ? void 0 : basket._id })];
                case 1:
                    activeLoan = _l.sent();
                    if (!(activeLoan.success && activeLoan.content && ((_c = activeLoan.content) === null || _c === void 0 ? void 0 : _c.empty) === false)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, application_1.update_loan_application)({
                            uid: activeLoan.content.id,
                            products: loanProducts,
                            basket_id: basket === null || basket === void 0 ? void 0 : basket._id,
                            amount: basket === null || basket === void 0 ? void 0 : basket.total,
                            term: airtimeOnly ? "1 Month" : "12 Months",
                            status: "DRAFT",
                            is_product: true,
                        })];
                case 2:
                    loanResponse = _l.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, (0, application_1.create_loan_application)({
                        products: loanProducts,
                        basket_id: basket === null || basket === void 0 ? void 0 : basket._id,
                        amount: basket === null || basket === void 0 ? void 0 : basket.total,
                        term: airtimeOnly ? "1 Month" : "12 Months",
                        status: "DRAFT",
                        is_product: true,
                        date_started: new Date(),
                    })];
                case 4:
                    loanResponse = _l.sent();
                    _l.label = 5;
                case 5:
                    if (loanResponse.success == false) {
                        setIsLoading(false);
                        dispatch((0, main_1.setMessageModal)({
                            title: "Something went wrong!",
                            messages: [loanResponse.message],
                        }));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0, functions_1.containsAirtime)(basket === null || basket === void 0 ? void 0 : basket.product_list)];
                case 6:
                    if (!_l.sent()) return [3 /*break*/, 11];
                    loanAirtimeProducts_1 = [];
                    (_d = basket === null || basket === void 0 ? void 0 : basket.product_list) === null || _d === void 0 ? void 0 : _d.forEach(function (product) {
                        var _a, _b, _c;
                        if (((_b = (_a = product === null || product === void 0 ? void 0 : product.category) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === constants_1.AIRTIME_TOPUP) {
                            loanAirtimeProducts_1.push({
                                amount: product === null || product === void 0 ? void 0 : product.price,
                                number: (_c = user === null || user === void 0 ? void 0 : user.cell_number) === null || _c === void 0 ? void 0 : _c.phone_number,
                                product: product === null || product === void 0 ? void 0 : product.title,
                                quantity: Number(product === null || product === void 0 ? void 0 : product.quantity),
                            });
                        }
                    });
                    return [4 /*yield*/, (0, get_airtime_record_1.getActiveAirtimePurchase)({ basket_id: basket === null || basket === void 0 ? void 0 : basket._id })];
                case 7:
                    activeAirtimePurchase = _l.sent();
                    if (!(activeAirtimePurchase.success && activeAirtimePurchase.content && ((_e = activeAirtimePurchase.content) === null || _e === void 0 ? void 0 : _e.empty) === false)) return [3 /*break*/, 9];
                    return [4 /*yield*/, (0, airtime_purchases_1.update_airtime_purchase)({
                            uid: (_f = activeAirtimePurchase === null || activeAirtimePurchase === void 0 ? void 0 : activeAirtimePurchase.content) === null || _f === void 0 ? void 0 : _f.uid,
                            airtime: loanAirtimeProducts_1,
                            basket_id: basket === null || basket === void 0 ? void 0 : basket._id,
                            payment_source: constants_1.LOAN.toUpperCase(),
                        }).then(function (response) {
                            if (!response.success) {
                                setIsLoading(false);
                                dispatch((0, main_1.setMessageModal)({
                                    title: "Something went wrong!",
                                    messages: [response.message],
                                }));
                                return;
                            }
                        })];
                case 8:
                    _l.sent();
                    return [3 /*break*/, 11];
                case 9: return [4 /*yield*/, (0, airtime_purchases_1.save_airtime_purchases)({
                        airtime: loanAirtimeProducts_1,
                        basket_id: basket === null || basket === void 0 ? void 0 : basket._id,
                        payment_source: constants_1.LOAN.toUpperCase(),
                    }).then(function (response) {
                        if (!response.success) {
                            setIsLoading(false);
                            dispatch((0, main_1.setMessageModal)({
                                title: "Something went wrong!",
                                messages: [response.message],
                            }));
                            return;
                        }
                    })];
                case 10:
                    _l.sent();
                    _l.label = 11;
                case 11:
                    devicesAmount = 0;
                    hasDevices = false;
                    return [4 /*yield*/, basket.product_list];
                case 12:
                    orderProducts = _l.sent();
                    // Check if there is a device on the order
                    orderProducts.forEach(function (product) {
                        var _a;
                        var categoryId = (_a = product === null || product === void 0 ? void 0 : product.category) === null || _a === void 0 ? void 0 : _a._id;
                        // Check if the product is a device
                        switch (categoryId) {
                            case process.env.CELLPHONE_CATEGORY_ID:
                            case process.env.SOLAR_CATEGORY_ID:
                            case process.env.HOME_APPLIANCE_CATEGORY_ID:
                            case process.env.FURNITURE_CATEGORY_ID:
                                hasDevices = true;
                                devicesAmount = devicesAmount + parseFloat(product === null || product === void 0 ? void 0 : product.price) * Number(product === null || product === void 0 ? void 0 : product.quantity);
                        }
                    });
                    if (!hasDevices) return [3 /*break*/, 16];
                    return [4 /*yield*/, (0, device_sale_agreement_1.create_device_sales_agreements)({
                            amount: "".concat(devicesAmount),
                            loan: (_g = loanResponse === null || loanResponse === void 0 ? void 0 : loanResponse.content) === null || _g === void 0 ? void 0 : _g.uid,
                            order_number: "",
                            type: constants_1.LOAN.toUpperCase(),
                        })];
                case 13:
                    saleAgreement = _l.sent();
                    if (!saleAgreement.success) return [3 /*break*/, 15];
                    return [4 /*yield*/, (0, application_1.update_loan_application)({
                            uid: (_h = loanResponse === null || loanResponse === void 0 ? void 0 : loanResponse.content) === null || _h === void 0 ? void 0 : _h.uid,
                            salesAgreement: (_j = saleAgreement === null || saleAgreement === void 0 ? void 0 : saleAgreement.content) === null || _j === void 0 ? void 0 : _j.uid,
                        }).then(function (response) {
                            var _a;
                            if (response.success) {
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                                navigate("".concat(route_names_1.ROUTE_LOAN_APPLICATION, "/").concat(steps_1.APP_STEP_START, "/").concat((_a = loanResponse === null || loanResponse === void 0 ? void 0 : loanResponse.content) === null || _a === void 0 ? void 0 : _a.uid));
                                setIsLoading(false);
                            }
                        })];
                case 14:
                    _l.sent();
                    _l.label = 15;
                case 15: return [3 /*break*/, 17];
                case 16:
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                    navigate("".concat(route_names_1.ROUTE_LOAN_APPLICATION, "/").concat(steps_1.APP_STEP_START, "/").concat((_k = loanResponse === null || loanResponse === void 0 ? void 0 : loanResponse.content) === null || _k === void 0 ? void 0 : _k.uid));
                    setIsLoading(false);
                    _l.label = 17;
                case 17: return [2 /*return*/];
            }
        });
    }); };
    var saveLaybuyDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var laybuyApplication, laybuyProducts, _i, _a, product, existingLaybuy, existingLaybuyData, branchId, providerId, defaultRefs, devicesAmount_1, hasDevices_1, orderProducts, saleAgreement;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    setIsLoading(true);
                    laybuyProducts = [];
                    for (_i = 0, _a = basket.product_list; _i < _a.length; _i++) {
                        product = _a[_i];
                        laybuyProducts.push({
                            name: product === null || product === void 0 ? void 0 : product.title,
                            price: product === null || product === void 0 ? void 0 : product.price,
                            quantity: product === null || product === void 0 ? void 0 : product.quantity,
                            category_id: (_b = product === null || product === void 0 ? void 0 : product.category) === null || _b === void 0 ? void 0 : _b._id,
                            id: product === null || product === void 0 ? void 0 : product._id,
                            sku: product === null || product === void 0 ? void 0 : product.sku,
                        });
                    }
                    return [4 /*yield*/, (0, get_laybuy_1.getBasketLaybuy)({ basket_id: basket === null || basket === void 0 ? void 0 : basket._id })];
                case 1:
                    existingLaybuy = _l.sent();
                    branchId = "";
                    providerId = "";
                    if (!(deliveryOrCollection === constants_1.COLLECTION)) return [3 /*break*/, 2];
                    // Use the selected branch for collection
                    branchId = ((_c = selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.branch) === null || _c === void 0 ? void 0 : _c._id) || "";
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, (0, getDefaultLaybuyReferences_1.getDefaultLaybuyReferences)()];
                case 3:
                    defaultRefs = _l.sent();
                    if (defaultRefs.success) {
                        providerId = defaultRefs.provider || "";
                        branchId = defaultRefs.branch || "";
                    }
                    else {
                        console.error("Failed to get default lay-buy references for delivery");
                    }
                    _l.label = 4;
                case 4:
                    if (!branchId) return [3 /*break*/, 6];
                    return [4 /*yield*/, (0, update_basket_1.update_basket)({
                            _id: (_d = basket === null || basket === void 0 ? void 0 : basket._id) !== null && _d !== void 0 ? _d : "",
                            basket: {
                                branch_id: branchId,
                            },
                        }).then(function (response) {
                            if (!response.success) {
                                console.error("Failed to update basket with branch");
                            }
                        })];
                case 5:
                    _l.sent();
                    _l.label = 6;
                case 6:
                    if (!(existingLaybuy && existingLaybuy.success && existingLaybuy.content && ((_e = existingLaybuy.content) === null || _e === void 0 ? void 0 : _e.empty) === false)) return [3 /*break*/, 8];
                    existingLaybuyData = existingLaybuy.content.docs.map(function (laybuy) { return (__assign({ id: laybuy.id }, laybuy.data())); });
                    return [4 /*yield*/, (0, application_2.update_laybuy_application)({
                            uid: (_f = existingLaybuyData[0]) === null || _f === void 0 ? void 0 : _f.id,
                            products: laybuyProducts,
                            basket_id: basket === null || basket === void 0 ? void 0 : basket._id,
                            amount: basket === null || basket === void 0 ? void 0 : basket.total,
                            status: "AWAITING-CHECKOUT",
                            branch: branchId,
                            provider: providerId,
                        })];
                case 7:
                    laybuyApplication = _l.sent();
                    return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, (0, application_2.create_laybuy_application)({
                        products: laybuyProducts,
                        basket_id: basket === null || basket === void 0 ? void 0 : basket._id,
                        amount: basket === null || basket === void 0 ? void 0 : basket.total,
                        status: "AWAITING-CHECKOUT",
                        is_product: true,
                        date_started: new Date(),
                        branch: branchId,
                        provider: providerId,
                    })];
                case 9:
                    laybuyApplication = _l.sent();
                    _l.label = 10;
                case 10:
                    if (!laybuyApplication.success) return [3 /*break*/, 16];
                    devicesAmount_1 = 0;
                    hasDevices_1 = false;
                    return [4 /*yield*/, basket.product_list];
                case 11:
                    orderProducts = _l.sent();
                    // Check if there is a device on the order
                    orderProducts.forEach(function (product) {
                        var _a;
                        var categoryId = (_a = product === null || product === void 0 ? void 0 : product.category) === null || _a === void 0 ? void 0 : _a._id;
                        // Check if the product is a device
                        switch (categoryId) {
                            case process.env.CELLPHONE_CATEGORY_ID:
                            case process.env.IOS_CATEGORY_ID:
                            case process.env.SOLAR_CATEGORY_ID:
                            case process.env.HOME_APPLIANCE_CATEGORY_ID:
                            case process.env.FURNITURE_CATEGORY_ID:
                                hasDevices_1 = true;
                                devicesAmount_1 = devicesAmount_1 + parseFloat(product === null || product === void 0 ? void 0 : product.price) * Number(product === null || product === void 0 ? void 0 : product.quantity);
                        }
                    });
                    if (!hasDevices_1) return [3 /*break*/, 15];
                    return [4 /*yield*/, (0, device_sale_agreement_1.create_device_sales_agreements)({
                            amount: "".concat(devicesAmount_1),
                            loan: (_g = laybuyApplication === null || laybuyApplication === void 0 ? void 0 : laybuyApplication.content) === null || _g === void 0 ? void 0 : _g.uid,
                            order_number: "",
                            type: "LAY-BUY",
                        })];
                case 12:
                    saleAgreement = _l.sent();
                    if (!saleAgreement.success) return [3 /*break*/, 14];
                    return [4 /*yield*/, (0, application_2.update_laybuy_application)({
                            uid: (_h = laybuyApplication === null || laybuyApplication === void 0 ? void 0 : laybuyApplication.content) === null || _h === void 0 ? void 0 : _h.uid,
                            sales_agreement_reference: (_j = saleAgreement === null || saleAgreement === void 0 ? void 0 : saleAgreement.content) === null || _j === void 0 ? void 0 : _j.uid,
                        }).then(function (response) {
                            var _a;
                            if (response.success) {
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                                navigate("".concat(route_names_1.ROUTE_LAYBUY_APPLICATION, "/").concat(steps_1.APP_STEP_START, "/").concat((_a = laybuyApplication === null || laybuyApplication === void 0 ? void 0 : laybuyApplication.content) === null || _a === void 0 ? void 0 : _a.uid));
                                setIsLoading(false);
                            }
                        })];
                case 13:
                    _l.sent();
                    _l.label = 14;
                case 14: return [3 /*break*/, 16];
                case 15:
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                    navigate("".concat(route_names_1.ROUTE_LAYBUY_APPLICATION, "/").concat(steps_1.APP_STEP_START, "/").concat((_k = laybuyApplication === null || laybuyApplication === void 0 ? void 0 : laybuyApplication.content) === null || _k === void 0 ? void 0 : _k.uid));
                    setIsLoading(false);
                    _l.label = 16;
                case 16: return [2 /*return*/];
            }
        });
    }); };
    var validateBranch = function () {
        var messages = [];
        var errorCount = 0;
        if (!selectedBranch) {
            // messages.push("Unfortunately, we do not deliver to this address. Please select a different address, or choose to collect.");
            messages.push("Please select a branch.");
        }
        if (messages.length > 0 || errorCount > 0) {
            if (messages.length > 0) {
                dispatch((0, main_1.setMessageModal)({ title: "Branch selection needed!", messages: messages }));
            }
            return false;
        }
        else {
            return true;
        }
    };
    var CheckoutPaymentButton = function (props) {
        var paymentType = props.paymentType;
        return (react_1.default.createElement(doshx_controls_web_1.BoxControl, { addPadding: true, shadowColor: "shadow-secondary", borderColor: paymentMethod == paymentType ? "border-primary" : "border-transparent" },
            react_1.default.createElement("div", { className: "flex gap-4 justify-center items-center" },
                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: paymentType == constants_1.CARD ? pro_solid_svg_icons_1.faCreditCard : paymentType == constants_1.LOAN ? pro_solid_svg_icons_1.faHandHoldingDollar : pro_regular_svg_icons_1.faMoneyBill, iconColor: "text-secondary", borderColor: "border-transparent" }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: paymentType == constants_1.CARD ? "Pay with card" : paymentType == constants_1.LOAN ? "Apply for loan" : "Apply for lay-buy", size: "small", textColor: "text-black" }),
                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: paymentMethod == paymentType ? pro_solid_svg_icons_1.faCircle : pro_light_svg_icons_1.faCircle, iconColor: paymentMethod == paymentType ? "text-primary" : "text-secondary", borderColor: "border-transparent", onClick: function () {
                        setPaymentMethod(paymentType);
                    } }))));
    };
    var RenderCheckoutButtons = function (props) {
        var paymentType = props.paymentType, index = props.index;
        if (payment) {
            if (paymentType === constants_1.LAYBUY && payment === "lay-buy") {
                return react_1.default.createElement(CheckoutPaymentButton, { key: index, paymentType: paymentType });
            }
            else {
                return null;
            }
        }
        else {
            if ((0, isIosProduct_1.isAllIosProducts)(basket)) {
                if (paymentType === constants_1.CARD) {
                    return react_1.default.createElement(CheckoutPaymentButton, { key: index, paymentType: constants_1.CARD });
                }
                else {
                    return null;
                }
            }
            else if (paymentType !== constants_1.LAYBUY) {
                return react_1.default.createElement(CheckoutPaymentButton, { key: index, paymentType: paymentType });
            }
            else {
                return null;
            }
        }
    };
    var customSteps = [
        {
            label: "Select how you would like to pay",
            component: (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement("div", { className: "flex gap-4" }, basket && constants_1.paymentTypes.map(function (paymentType, index) { return react_1.default.createElement(RenderCheckoutButtons, { key: index, index: index, paymentType: paymentType }); })),
                react_1.default.createElement("div", { className: "flex flex-row" }, paymentMethod == constants_1.LOAN && airtimeOnly ? (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Proceed", backgroundColor: "bg-primary", size: "small", loading: isLoading, enabled: !isLoading, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, saveLoanDetails()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); } })) : (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", backgroundColor: "bg-primary", size: "small", loading: isGettingBranches, enabled: !isGettingBranches, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var clearData, checkCookie_1, handleVerificationSuccess;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    setIsGettingBranches(true);
                                    if (!validatePaymentMethod()) return [3 /*break*/, 3];
                                    setIsGettingBranches(false);
                                    if (!(paymentMethod == constants_1.LOAN || paymentMethod == constants_1.LAYBUY)) return [3 /*break*/, 1];
                                    onNext();
                                    return [3 /*break*/, 3];
                                case 1: return [4 /*yield*/, (0, clear_action_auth_1.clear_action_auth)()];
                                case 2:
                                    clearData = _a.sent();
                                    if (!clearData.success) {
                                        return [2 /*return*/];
                                    }
                                    checkCookie_1 = function () {
                                        var userStateCookie = cookie.get("user_state");
                                        if (userStateCookie === null || userStateCookie === void 0 ? void 0 : userStateCookie.facetec.action_authenticated) {
                                            clearInterval(intervalId);
                                            onNext();
                                        }
                                        else {
                                        }
                                    };
                                    handleVerificationSuccess = function () {
                                        // Use an interval to check for changes in the cookie
                                        intervalId = setInterval(checkCookie_1, 5000); // Check every 5 second
                                        sampleAppController_1.SampleApp.onAuthenticateUserPressed();
                                    };
                                    dispatch((0, main_1.setContentModal)({
                                        title: "Prominent Influential Person (PIP) Declaration",
                                        content: react_1.default.createElement(pep_pip_verification_1.PepPipVerification, { onProceed: handleVerificationSuccess }),
                                    }));
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); } }))))),
        },
        {
            label: "Choose Delivery or Collection",
            hidden: paymentMethod == constants_1.LOAN || airtimeOnly,
            component: (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement(doshx_controls_web_1.RadioButtonsControl, { title: "Delivery Method", colors: control_colors_1.radio_colors, selectedValue: deliveryOrCollection, options: [
                        { label: "Delivery", value: constants_1.DELIVERY },
                        { label: "Collection", value: constants_1.COLLECTION },
                    ], onChange: function (value) {
                        setDeliveryOrCollection(value);
                    } }),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", backgroundColor: "bg-primary", size: "small", loading: isGettingBranches, enabled: !isGettingBranches, onClick: function () {
                            if (validateDeliveryMethod()) {
                                dispatch((0, basket_1.setDeliveryMethod)(deliveryOrCollection));
                                onNext();
                            }
                            // setIsAddingAddress(false);
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Back", size: "small", onClick: function () {
                            onPrevious();
                        } })))),
        },
        {
            label: "Choose Phone Number",
            hidden: paymentMethod == constants_1.LOAN || paymentMethod == constants_1.LAYBUY || !airtimeOnly,
            component: (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Is the airtime for you?", value: !rechargingAnotherParty, onChange: function () {
                        setRechargingAnotherParty(!rechargingAnotherParty);
                    } }),
                rechargingAnotherParty ? (react_1.default.createElement("div", null,
                    react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Phone Number", value: rechargePhoneNumber === null || rechargePhoneNumber === void 0 ? void 0 : rechargePhoneNumber.phone_number, size: "small", errorText: "", defaultCountryCode: (_a = rechargePhoneNumber === null || rechargePhoneNumber === void 0 ? void 0 : rechargePhoneNumber.country_abbreviation) !== null && _a !== void 0 ? _a : "NA", showExtension: false, showFlag: false, onChange: function (v) {
                            return setRechargePhoneNumber(__assign(__assign({}, rechargePhoneNumber), { phone_number: v }));
                        }, onExtensionChange: function (ext, code) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                setRechargePhoneNumber(__assign(__assign({}, rechargePhoneNumber), { phone_number: rechargePhoneNumber === null || rechargePhoneNumber === void 0 ? void 0 : rechargePhoneNumber.phone_number }));
                                return [2 /*return*/];
                            });
                        }); }, international: true }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "small", label: "By proceeding you agree that it is your duty to ensure the correctness of the target mobile number as expressed above, and you will have no claim for refund in case of incorrect number." }))) : (react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (_b = user === null || user === void 0 ? void 0 : user.cell_number) === null || _b === void 0 ? void 0 : _b.phone_number, bold: true, textColor: "text-gray", size: "medium" })),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", backgroundColor: "bg-primary", size: "small", loading: isGettingBranches, enabled: !isGettingBranches, onClick: function () {
                            var _a;
                            if (validateRechargePhoneNumber()) {
                                if (rechargingAnotherParty) {
                                    dispatch((0, set_checkout_local_storage_thunk_1.set_checkout_local_storage_thunk)({ recharge_phone_number: rechargePhoneNumber === null || rechargePhoneNumber === void 0 ? void 0 : rechargePhoneNumber.phone_number }));
                                }
                                else {
                                    dispatch((0, set_checkout_local_storage_thunk_1.set_checkout_local_storage_thunk)({ recharge_phone_number: (_a = user === null || user === void 0 ? void 0 : user.cell_number) === null || _a === void 0 ? void 0 : _a.phone_number }));
                                }
                                onNext();
                            }
                            // setIsAddingAddress(false);
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Back", size: "small", onClick: function () {
                            onPrevious();
                        } })))),
        },
        {
            label: "Select Address",
            hidden: airtimeOnly || paymentMethod == constants_1.LOAN || deliveryOrCollection == constants_1.COLLECTION,
            component: (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                isAddingAddress ? (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.AddressSearchControl, { letsTradeAPIUrl: process.env.LETS_TRADE_CLIENT_URL, value: selectedAddress, required: true, label: "Search Address", size: "medium", onSelectionChange: function (addressObject) {
                            if (addressObject) {
                                setSelectedAddress({
                                    full_address: addressObject.fullAddress,
                                    longitude: addressObject.coordinates.lng.toString(),
                                    latitude: addressObject.coordinates.lat.toString(),
                                });
                            }
                        } }),
                    selectedAddress && (react_1.default.createElement("div", { className: "flex flex-col rounded-lg border border-primary" },
                        react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center p-2 pl-4" },
                            react_1.default.createElement("div", { className: "flex-1" }, selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.full_address),
                            react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Save this address?", value: saveAddress, onChange: function (v) {
                                    setSaveAddress(v);
                                } })),
                        saveAddress && (react_1.default.createElement("div", { className: "px-2 pb-2" },
                            react_1.default.createElement("div", { className: "w-1/2" },
                                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Name this address", size: "small", errorText: newAddressErrorText, value: newAddressLabel, onChange: function (v) {
                                        setNewAddressLabel(v);
                                    } })))))))) : (react_1.default.createElement("div", null,
                    react_1.default.createElement("div", null, addressList && addressList.length > 0 ? (react_1.default.createElement("div", { className: "flex flex-col gap-4" }, addressList.map(function (address, index) {
                        return (react_1.default.createElement("div", { key: index, className: "p-4 rounded-md border border-gray-400 cursor-pointer", onClick: function () {
                                setSelectedAddress({
                                    full_address: address === null || address === void 0 ? void 0 : address.full_address,
                                    longitude: address.longitude,
                                    latitude: address.latitude,
                                });
                                // onNext();
                            } },
                            react_1.default.createElement("div", { className: "flex flex-row items-center" },
                                react_1.default.createElement("div", { className: "flex flex-col flex-1" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: address.label, className: "cursor-pointer" //
                                        , textColor: "text-black" }),
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: address.full_address, className: "cursor-pointer" //
                                        , textColor: "text-black", size: "xsmall" })),
                                address.full_address == (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.full_address) && (react_1.default.createElement("div", { className: "flex flex-row items-center px-2 py-1 rounded-lg bg-primary" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "SELECTED", className: "cursor-pointer" //
                                        , textColor: "text-white", size: "xsmall" }))))));
                    }))) : (react_1.default.createElement("div", null,
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "You don't have any saved addresses. Please add an address." })))))),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", backgroundColor: "bg-primary", size: "small", loading: isGettingBranches, enabled: !isGettingBranches, onClick: function () {
                            var _a, _b, _c, _d, _e, _f, _g;
                            if (validateAddress()) {
                                if (saveAddress) {
                                    (0, add_user_address_1.add_user_address)({
                                        label: newAddressLabel,
                                        full_address: (_a = selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.full_address) !== null && _a !== void 0 ? _a : "",
                                        latitude: (_b = selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.latitude) !== null && _b !== void 0 ? _b : "",
                                        longitude: (_c = selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.longitude) !== null && _c !== void 0 ? _c : "",
                                        is_residential: true,
                                        complex_building_details: "",
                                    }).then(function (response) {
                                        if (response.success) {
                                            setAddressList(__spreadArray([], addressList, true));
                                        }
                                        else {
                                            dispatch((0, main_1.setMessageModal)({
                                                title: "Could not save user address.",
                                                messages: [response.message],
                                            }));
                                        }
                                    });
                                }
                                (0, update_basket_1.update_basket)({
                                    _id: (_d = basket === null || basket === void 0 ? void 0 : basket._id) !== null && _d !== void 0 ? _d : "",
                                    basket: {
                                        type: deliveryOrCollection,
                                        provider: basket.provider,
                                        branch_id: (_e = selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.branch) === null || _e === void 0 ? void 0 : _e._id,
                                        address: {
                                            full_address: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.full_address,
                                            latitude: (_f = selectedAddress.latitude) === null || _f === void 0 ? void 0 : _f.toString(),
                                            longitude: (_g = selectedAddress.longitude) === null || _g === void 0 ? void 0 : _g.toString(),
                                        },
                                    },
                                }).then(function (response) {
                                    if (response.success) {
                                        dispatch((0, get_basket_thunk_1.get_basket_thunk)({ basket_id: basket === null || basket === void 0 ? void 0 : basket._id }));
                                    }
                                });
                                onNext();
                            }
                        } }),
                    isAddingAddress ? (react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Show address list", size: "small", onClick: function () {
                            setSelectedAddress(null);
                            setIsAddingAddress(false);
                        } })) : (react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Add address", size: "small", onClick: function () {
                            setSelectedAddress(null);
                            setIsAddingAddress(true);
                        } })),
                    react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Back", size: "small", onClick: function () {
                            onPrevious();
                        } })))),
        },
        {
            label: CHECKOUT_STEP_LABEL_CHOOSE_BRANCH,
            hidden: airtimeOnly || deliveryOrCollection == constants_1.DELIVERY,
            component: (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement("div", { className: "flex flex-col gap-4 lg:flex-row" },
                    react_1.default.createElement("div", { className: "flex-none flex-row lg:flex-col gap-8 lg:max-w-[25rem] px-4" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Find A Store", textColor: "text-black", bold: true, size: "2xlarge" }),
                        react_1.default.createElement("div", { className: "flex flex-col gap-4 p-2 rounded-md shadow-sm" },
                            react_1.default.createElement("div", { className: "flex flex-col gap-2" },
                                react_1.default.createElement(doshx_controls_web_1.AddressSearchControl, { letsTradeAPIUrl: process.env.LETS_TRADE_CLIENT_URL, label: "Enter a city or suburb", borderColor: "border-[#EEEEEE]", value: searchAddress, errorText: "", iconColor: "text-primary", onSelectionChange: function (v) {
                                        setSearchAddress(v);
                                    } }),
                                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Find a store near me", startIcon: pro_solid_svg_icons_1.faLocationCrosshairs, iconColor: "text-primary", textColor: "text-primary", size: "xsmall", backgroundColor: "bg-transparent", onClick: function () {
                                        getUserLocation();
                                    } })),
                            isGettingBranches ? (react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "small", progressColor: "text-primary" })) : (react_1.default.createElement("div", { className: "flex flex-col gap-2" }, nearestBranches && nearestBranches.length > 0 ? (react_1.default.createElement("div", { className: "flex overflow-x-auto gap-4 pb-2" }, nearestBranches
                                .filter(function (x) {
                                return branchSearchText.toLowerCase()
                                    ? x.branch.display_name.toLowerCase().includes(branchSearchText) ||
                                        x.branch.address.full_address.toLowerCase().includes(branchSearchText)
                                    : true;
                            })
                                .map(function (branch, index) {
                                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                                return (react_1.default.createElement("div", { className: "flex-none w-80", key: index },
                                    react_1.default.createElement("div", { className: "p-4 h-full rounded-lg border border-gray-200" },
                                        react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                                            react_1.default.createElement("div", { className: "flex flex-row gap-2 justify-between items-center" },
                                                react_1.default.createElement("div", { className: "flex flex-row gap-2 items-center w-9/12" },
                                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (_a = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _a === void 0 ? void 0 : _a.display_name, textColor: "text-gray-900", bold: true, size: "medium" })),
                                                react_1.default.createElement("div", { className: "flex flex-row gap-2 items-center w-3/12 cursor-pointer", onClick: function () {
                                                        var _a, _b, _c, _d;
                                                        window.open("http://maps.google.com/maps?daddr=" + ((_b = (_a = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.latitude) + "," + ((_d = (_c = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.longitude), "_blank");
                                                    } },
                                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faDiamondTurnRight, size: "1x" }),
                                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Directions", textColor: "text-primary", size: "xsmall" }))),
                                            react_1.default.createElement("div", { className: "flex flex-row gap-2 justify-between items-center w-full" },
                                                react_1.default.createElement("div", { className: "flex flex-row gap-2 items-center w-9/12" },
                                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (_c = (_b = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.full_address, textColor: "text-gray-600", size: "small" })),
                                                react_1.default.createElement("div", { className: "flex flex-row gap-1 items-center w-3/12" },
                                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faLocationArrow, size: "xs" }),
                                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "".concat(branch === null || branch === void 0 ? void 0 : branch.distance, " KM"), textColor: "text-black", size: "xsmall" }))),
                                            react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: (_d = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _d === void 0 ? void 0 : _d.contact_number, icon: pro_solid_svg_icons_1.faPhone, iconColor: "text-black", textColor: "text-primary", size: "small", onClick: function () {
                                                    var _a;
                                                    window.open("tel:".concat((_a = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _a === void 0 ? void 0 : _a.contact_number), "_blank");
                                                } }),
                                            react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: (_e = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _e === void 0 ? void 0 : _e.email, icon: pro_solid_svg_icons_1.faEnvelope, iconColor: "text-black", textColor: "text-primary", size: "small", onClick: function () {
                                                    var _a;
                                                    window.open("mailto:".concat((_a = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _a === void 0 ? void 0 : _a.email, "}"), "_blank");
                                                } }),
                                            react_1.default.createElement(doshx_controls_web_1.AccordionControl, { colors: {
                                                    titleTextColor: "text-success",
                                                    titleBackgroundColor: "bg-transparent",
                                                    contentTextColor: "text-black",
                                                    contentBackgroundColor: "bg-white",
                                                    borderColor: "border-transparent",
                                                    divideColor: "divide-gray-200",
                                                }, addHeaderPadding: false, addContentPadding: false, arrowSide: "right", items: [
                                                    {
                                                        expanded: false,
                                                        header: (react_1.default.createElement("div", { className: "flex flex-row gap-2 items-center w-full" },
                                                            react_1.default.createElement("div", { className: "w-.5/12" },
                                                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faClock, size: "xs" })),
                                                            react_1.default.createElement("div", { className: "flex flex-row gap-2 justify-between items-center w-11/12" },
                                                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (_g = (_f = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _f === void 0 ? void 0 : _f.working_hours.find(function (x) { return x.day === new Date().toLocaleString("default", { weekday: "long" }); })) === null || _g === void 0 ? void 0 : _g.day, textColor: "text-success", size: "small" }),
                                                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Open ".concat((_j = (_h = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _h === void 0 ? void 0 : _h.working_hours.find(function (x) { return x.day === new Date().toLocaleString("default", { weekday: "long" }); })) === null || _j === void 0 ? void 0 : _j.from, " - ").concat((_l = (_k = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _k === void 0 ? void 0 : _k.working_hours.find(function (x) { return x.day === new Date().toLocaleString("default", { weekday: "long" }); })) === null || _l === void 0 ? void 0 : _l.to), textColor: "text-success", size: "small" })))),
                                                        content: (react_1.default.createElement("div", { className: "" }, (_o = (_m = branch === null || branch === void 0 ? void 0 : branch.branch) === null || _m === void 0 ? void 0 : _m.working_hours) === null || _o === void 0 ? void 0 : _o.map(function (hours, hours_index) {
                                                            return (react_1.default.createElement("div", { className: "flex flex-row gap-2 justify-between items-center", key: hours_index },
                                                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: hours === null || hours === void 0 ? void 0 : hours.day, textColor: "text-black", size: "small" }),
                                                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "".concat(hours === null || hours === void 0 ? void 0 : hours.from, " - ").concat(hours === null || hours === void 0 ? void 0 : hours.to), textColor: "text-black", size: "small" })));
                                                        }))),
                                                    },
                                                ] }),
                                            react_1.default.createElement("div", { className: "flex flex-row justify-center" },
                                                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "SELECT THIS STORE", backgroundColor: "bg-primary", textColor: "text-white", size: "xsmall", onClick: function () {
                                                        setSelectedBranch(branch);
                                                    } })),
                                            branch == selectedBranch && (react_1.default.createElement("div", { className: "flex flex-row items-center px-2 py-1 rounded-lg bg-primary" },
                                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "SELECTED", className: "cursor-pointer", textColor: "text-white", size: "xsmall" })))))));
                            }))) : (react_1.default.createElement("div", null, searchAddress ? (react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "No stores found near this location. Please try a different address or location.", textColor: "text-error" })) : (react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Please search for a location to find nearby stores.", textColor: "text-error" })))))))),
                    react_1.default.createElement("div", { className: "flex-1 h-[50vh]" },
                        react_1.default.createElement(doshx_controls_web_1.MapControl, { controlSize: "large", zoom: 8, center: {
                                lat: Number((_g = (_e = (_d = (_c = plotData[0]) === null || _c === void 0 ? void 0 : _c.position) === null || _d === void 0 ? void 0 : _d.lat) !== null && _e !== void 0 ? _e : (_f = searchAddress === null || searchAddress === void 0 ? void 0 : searchAddress.coordinates) === null || _f === void 0 ? void 0 : _f.lat) !== null && _g !== void 0 ? _g : -22.5635767),
                                lng: Number((_m = (_k = (_j = (_h = plotData[0]) === null || _h === void 0 ? void 0 : _h.position) === null || _j === void 0 ? void 0 : _j.lng) !== null && _k !== void 0 ? _k : (_l = searchAddress === null || searchAddress === void 0 ? void 0 : searchAddress.coordinates) === null || _l === void 0 ? void 0 : _l.lng) !== null && _m !== void 0 ? _m : 16.9798253),
                            }, markers: plotData }))),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                    paymentMethod == constants_1.LOAN || paymentMethod == constants_1.LAYBUY ? (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Proceed", backgroundColor: "bg-primary", size: "small", loading: isLoading, enabled: !isLoading, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!validateBranch()) return [3 /*break*/, 4];
                                        if (!(paymentMethod == constants_1.LOAN)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, saveLoanDetails()];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        if (!(paymentMethod == constants_1.LAYBUY)) return [3 /*break*/, 4];
                                        return [4 /*yield*/, saveLaybuyDetails()];
                                    case 3:
                                        _a.sent();
                                        _a.label = 4;
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); } })) : (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", backgroundColor: "bg-primary", size: "small", onClick: function () {
                            if (validateBranch()) {
                                onNext();
                            }
                        } })),
                    react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Back", size: "small", onClick: function () {
                            onPrevious();
                        } })))),
        },
        {
            hidden: deliveryOrCollection == constants_1.COLLECTION || airtimeOnly,
            label: "Special Instructions",
            component: (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement("div", { className: "flex flex-col" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Optionally provide any special instructions." }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "For example: \"Hoot at gate.\"", size: "xsmall" })),
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Special Instructions", lines: 4, size: "small", borderColor: "border-gray-400", value: specialInstructions, onChange: function (v) {
                        setSpecialInstructions(v);
                    } }),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: paymentMethod === constants_1.LAYBUY ? "Proceed to Lay-buy Application" : "Next", backgroundColor: "bg-primary", size: "small", loading: paymentMethod === constants_1.LAYBUY ? isLoading : isGettingBranches, enabled: paymentMethod === constants_1.LAYBUY ? !isLoading : !isGettingBranches, onClick: function () {
                            var _a, _b, _c, _d;
                            (0, update_basket_1.update_basket)({
                                _id: (_a = basket === null || basket === void 0 ? void 0 : basket._id) !== null && _a !== void 0 ? _a : "",
                                basket: {
                                    type: deliveryOrCollection,
                                    provider: basket.provider,
                                    branch_id: (_b = selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.branch) === null || _b === void 0 ? void 0 : _b._id,
                                    address: {
                                        full_address: selectedAddress.full_address,
                                        latitude: (_c = selectedAddress.latitude) === null || _c === void 0 ? void 0 : _c.toString(),
                                        longitude: (_d = selectedAddress.longitude) === null || _d === void 0 ? void 0 : _d.toString(),
                                    },
                                },
                            }).then(function (response) {
                                if (response.success) {
                                    dispatch((0, get_basket_thunk_1.get_basket_thunk)({ basket_id: basket === null || basket === void 0 ? void 0 : basket._id }));
                                }
                            });
                            // If lay-buy, trigger the lay-buy application flow
                            if (paymentMethod === constants_1.LAYBUY) {
                                saveLaybuyDetails();
                            }
                            else {
                                onNext();
                            }
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Back", size: "small", onClick: function () {
                            onPrevious();
                        } })))),
        },
        {
            label: "Payment Method",
            hidden: paymentMethod == constants_1.LOAN || paymentMethod == constants_1.LAYBUY,
            component: (react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" }, ngeniusLoading ? (react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "large" })) : (react_1.default.createElement("div", { onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var productList, myAirtimeProducts, productMappings_1, error_1;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    setNgeniusLoading(true);
                                    productList = (_a = basket === null || basket === void 0 ? void 0 : basket.product_list) !== null && _a !== void 0 ? _a : [];
                                    myAirtimeProducts = [];
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, Promise.all(productList.map(function (product) { var _a, _b; return ((_b = (_a = product === null || product === void 0 ? void 0 : product.category) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === constants_1.AIRTIME_TOPUP ? Promise.resolve(null) : (0, airtimeProductHelper_1.getAirtimeProductMapping)(product.title); }))];
                                case 2:
                                    productMappings_1 = _b.sent();
                                    productList.forEach(function (product, index) {
                                        var _a, _b, _c, _d;
                                        if (((_b = (_a = product === null || product === void 0 ? void 0 : product.category) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === constants_1.AIRTIME_TOPUP) {
                                            myAirtimeProducts.push({
                                                amount: product === null || product === void 0 ? void 0 : product.price,
                                                number: rechargingAnotherParty ? rechargePhoneNumber === null || rechargePhoneNumber === void 0 ? void 0 : rechargePhoneNumber.phone_number : (_c = user === null || user === void 0 ? void 0 : user.cell_number) === null || _c === void 0 ? void 0 : _c.phone_number,
                                                product: product === null || product === void 0 ? void 0 : product.title,
                                                quantity: Number(product === null || product === void 0 ? void 0 : product.quantity),
                                            });
                                        }
                                        var result = productMappings_1[index];
                                        if (result) {
                                            myAirtimeProducts.push({
                                                amount: result.amount,
                                                number: rechargingAnotherParty ? rechargePhoneNumber === null || rechargePhoneNumber === void 0 ? void 0 : rechargePhoneNumber.phone_number : (_d = user === null || user === void 0 ? void 0 : user.cell_number) === null || _d === void 0 ? void 0 : _d.phone_number,
                                                product: result.airtime_product_name,
                                                quantity: Number(result.quantity) * Number(product.quantity),
                                            });
                                        }
                                    });
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _b.sent();
                                    console.error("Could not resolve airtime product mappings before payment:", error_1);
                                    setNgeniusLoading(false);
                                    dispatch((0, main_1.setMessageModal)({
                                        title: "Could not prepare your payment!",
                                        messages: ["We couldn't verify the airtime included with your products. Please try again."],
                                    }));
                                    return [2 /*return*/];
                                case 4:
                                    (0, create_order_1.create_order)({
                                        amount: basket === null || basket === void 0 ? void 0 : basket.total,
                                        redirect_url: "".concat(ngeniuRedirectURL, "/#/outcome/success"),
                                        reference: {
                                            key: "basket",
                                            value: basket === null || basket === void 0 ? void 0 : basket._id,
                                        },
                                    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                                        var redirectUrl;
                                        var _a, _b;
                                        return __generator(this, function (_c) {
                                            switch (_c.label) {
                                                case 0:
                                                    setNgeniusLoading(false);
                                                    if (!response.success) return [3 /*break*/, 3];
                                                    if (!(myAirtimeProducts.length > 0)) return [3 /*break*/, 2];
                                                    //Save Data
                                                    return [4 /*yield*/, (0, airtime_purchases_1.save_airtime_purchases)({
                                                            airtime: myAirtimeProducts,
                                                            basket_id: basket === null || basket === void 0 ? void 0 : basket._id,
                                                            payment_source: (_a = paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.toUpperCase()) !== null && _a !== void 0 ? _a : "",
                                                        }).then(function (response) {
                                                            if (response.success) {
                                                            }
                                                            else {
                                                                dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                                                            }
                                                        })];
                                                case 1:
                                                    //Save Data
                                                    _c.sent();
                                                    _c.label = 2;
                                                case 2:
                                                    if (rechargingAnotherParty) {
                                                        dispatch((0, set_checkout_local_storage_thunk_1.set_checkout_local_storage_thunk)({ recharge_phone_number: rechargePhoneNumber === null || rechargePhoneNumber === void 0 ? void 0 : rechargePhoneNumber.phone_number }));
                                                    }
                                                    else {
                                                        dispatch((0, set_checkout_local_storage_thunk_1.set_checkout_local_storage_thunk)({ recharge_phone_number: (_b = user === null || user === void 0 ? void 0 : user.cell_number) === null || _b === void 0 ? void 0 : _b.phone_number }));
                                                    }
                                                    redirectUrl = response.content.order._links.payment.href;
                                                    // Redirect to NGenius
                                                    window.location.replace(redirectUrl);
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    dispatch((0, main_1.setMessageModal)({
                                                        title: "Something went wrong while creating the NGenius order!",
                                                        messages: [response.message],
                                                    }));
                                                    _c.label = 4;
                                                case 4: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                    return [2 /*return*/];
                            }
                        });
                    }); }, className: "p-2 rounded-md bg-secondary" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Pay Now", textColor: "text-white", size: "large" })))),
                react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Back", size: "small", onClick: function () {
                        onPrevious();
                    } }))),
        },
        // {
        //   label: "Loan Application",
        //   hidden: paymentMethod != LOAN || airtimeOnly,
        //   component: (
        //     <div className="flex flex-col gap-4">
        //       <div className="flex flex-col gap-4">
        //         <LabelControl label="Loan Amount" size="medium" textColor="text-black" />
        //         <TextInputControl
        //           label="Amount"
        //           value={Utilities.formatMoney({ symbol: currencySymbol, value: parseFloat(basket?.total.toString() ?? "0").toString(), decimalPlaces: 2 })}
        //           textColor="text-black"
        //           size="medium"
        //           disabled
        //         />
        //       </div>
        //       <div className="flex flex-row gap-4 justify-start items-center">
        //         <ButtonControl
        //           label="Proceed"
        //           backgroundColor="bg-primary"
        //           size="small"
        //           loading={isLoading}
        //           onClick={async () => {
        //             await saveLoanDetails();
        //           }}
        //         />
        //         <LinkButtonControl
        //           label="Back"
        //           size="small"
        //           onClick={() => {
        //             onPrevious();
        //           }}
        //         />
        //       </div>
        //     </div>
        //   ),
        // },
    ];
    return (react_1.default.createElement("div", { className: "flex flex-col gap-8" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-4 lg:flex-row lg:items-start" },
            react_1.default.createElement("div", { className: "flex-grow" },
                react_1.default.createElement(doshx_controls_web_1.StepperControl, { stepPillBackgroundColor: "bg-primary", lineColor: "border-primary", currentStep: currentStep, steps: customSteps })),
            react_1.default.createElement("div", { id: "status", className: "hidden" }),
            react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "flex flex-col flex-none" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Order Summary", textColor: "text-black", size: "large" }),
                    selectedBranch &&
                        (selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.branch) &&
                        !airtimeOnly && ( //TODO we need to check if the branch is selected and that it is not NULL when ew press "Next"
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(doshx_controls_web_1.DividerControl, null),
                        react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                            react_1.default.createElement("div", { className: "flex-1" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (_o = selectedBranch.branch.display_name) !== null && _o !== void 0 ? _o : "", size: "small", textColor: "text-black" })),
                            react_1.default.createElement("div", { className: "flex flex-row items-center px-2 py-1 rounded-lg bg-primary" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: deliveryOrCollection.toUpperCase(), size: "xsmall", textColor: "text-white" }))))),
                    react_1.default.createElement(doshx_controls_web_1.DividerControl, null),
                    react_1.default.createElement("div", null, basket &&
                        basket.product_list.map(function (product, index) {
                            var _a;
                            return (react_1.default.createElement("div", { key: index, className: "flex flex-row justify-between items-center" },
                                react_1.default.createElement("div", { className: "pr-4 pb-[2px] flex flex-row gap-2 justify-center items-center text-secondary" },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: product.title, textColor: "text-black" }),
                                    " ",
                                    product.on_promotion ? react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faTag }) : ""),
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                        symbol: symbols_1.currencySymbol,
                                        value: product.on_promotion ? product.promotion_price : ((_a = product.price) !== null && _a !== void 0 ? _a : "0"),
                                    }), textColor: "text-black" })));
                        }))),
                react_1.default.createElement(doshx_controls_web_1.DividerControl, null),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "flex flex-row justify-between" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Subtotal", textColor: "text-black" }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({ symbol: symbols_1.currencySymbol, value: (_p = basket === null || basket === void 0 ? void 0 : basket.total.toString()) !== null && _p !== void 0 ? _p : "0", decimalPlaces: 2 }), textColor: "text-black" })),
                    deliveryOrCollection == constants_1.DELIVERY && (react_1.default.createElement("div", { className: "flex flex-row justify-between" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Delivery", textColor: "text-black" }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({
                                symbol: symbols_1.currencySymbol,
                                value: (_t = (_s = (_r = (_q = selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.branch) === null || _q === void 0 ? void 0 : _q.delivery) === null || _r === void 0 ? void 0 : _r.delivery_fee) === null || _s === void 0 ? void 0 : _s.toString()) !== null && _t !== void 0 ? _t : "0",
                                decimalPlaces: 2,
                            }), textColor: "text-black" })))),
                react_1.default.createElement(doshx_controls_web_1.DividerControl, null),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 justify-between" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Order Total", textColor: "text-black", size: "large" }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_1.Utilities.formatMoney({ symbol: symbols_1.currencySymbol, value: parseFloat((_u = basket === null || basket === void 0 ? void 0 : basket.total.toString()) !== null && _u !== void 0 ? _u : "0").toString(), decimalPlaces: 2 }), textColor: "text-black", size: "large" })))),
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "" })));
};
exports.CheckoutPage = CheckoutPage;
